<template>
  <div>
    <a-modal :visible="modalVisible" :title="data.team_name" :closable="false" :width="1000" @cancel="closeModal">
      <a-table :columns="modalIssueColumns" :data-source="tableData" :width="800">
        <span slot="issueTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.title">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
          </a-tooltip>
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalVisible: false,
      data: [],
      tableData: [],
      modalIssueColumns: [
        {
          title: 'ID',
          dataIndex: 'id',
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '缺陷标题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'issueTitle' }
        },
        {
          title: '响应时长',
          width: 120,
          dataIndex: 'response_time_str',
          scopedSlots: { customRender: 'response_time' },
          sorter: (a, b) => a.response_time - b.response_time
        },
        {
          title: '处理人',
          width: 100,
          dataIndex: 'handler',
          scopedSlots: { customRender: 'handler' }
        }
      ]
    };
  },
  computed: {
    link() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          query: { issueId: record.id },
          params: { project_id: record.project_id }
        });
        return route.href;
      };
    }
  },
  methods: {
    closeModal() {
      this.modalVisible = false;
    },
    open(getData, getTableData) {
      this.modalVisible = true;
      this.data = getData;
      this.tableData = getTableData;
    }
  }
};
</script>
